import React from "react";
import { Link } from "react-router-dom";
import linkedIn from "../../assets/linkedInBlack.svg";
import facebook from "../../assets/facebookBlack.svg";
import youtube from "../../assets/youtubeBlack.svg";
import Insta from "../../assets/Group.svg";
import Thanks from "../../assets/thanks.gif";

const ThankyouScreen = ({
  title,
  message,
  message2,
  className = "max-w-[798px] font-bold",
}) => {
  return (
    <div className="relative w-full text-center flex justify-center mb-36">
      <div
        className={`${className} flex flex-col items-center justify-center gap-6 mt-12 z-10`}
      >
        <h1 className="text-darkPurple font-bold text-[40px]">{title}</h1>
        <p className="text-lg text-darkGray/80 font-medium">{message}</p>
        {message2}
        <div className="flex gap-6 max-lg:mt-4">
          <Link
            to="https://www.linkedin.com/company/regtechflow/"
            className="font-medium hover:text-darkPurple"
            target="_blank"
          >
            {" "}
            <img src={linkedIn} alt="linkedIn" width={24} height={24} />
          </Link>
          <Link
            to="https://www.facebook.com/share/1E9RNNJx29/"
            className="font-medium hover:text-darkPurple"
            target="_blank"
          >
            {" "}
            <img src={facebook} alt="facebook" width={24} height={24} />
          </Link>
          <Link
            to="https://www.instagram.com/regtechflow?igsh=ajliZjB3ZHdjamRw"
            className="font-medium hover:text-darkPurple"
            target="_blank"
          >
            {" "}
            <img src={Insta} alt="insta" width={24} height={24} />
          </Link>
          <Link
            to="https://youtu.be/Uo4vA9u1CNk"
            className="text-[#1E1E1E]/70 font-medium hover:text-[#6200EE] mt-[2px]"
            target="_blank"
          >
            {" "}
            <img src={youtube} alt="youtube" width={24} height={24} />
          </Link>
        </div>
      </div>
      <div className="absolute top-0">
        <img src={Thanks} alt="thankyou-gif" style={{ height: 450 }} />
      </div>
    </div>
  );
};

export default ThankyouScreen;
